import CryptoJS from 'crypto-js';

export const encrypt = (text: string, key: string): string => {
    try {
        return CryptoJS.AES.encrypt(text, key).toString();
    } catch (error) {
        console.error('Encryption error:', error);
        throw new Error('Failed to encrypt data');
    }
};

export const decrypt = (encryptedText: string, key: string): string => {
    try {
        const bytes = CryptoJS.AES.decrypt(encryptedText, key);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        if (!decrypted) {
            throw new Error('Decryption failed - invalid key or data');
        }
        return decrypted;
    } catch (error) {
        console.error('Decryption error:', error);
        throw new Error('Failed to decrypt data');
    }
}; 